import { useState, useEffect } from "react";
import geoService from "../../services/geoService";

const useCurrencyPrices = (code) => {
    const [currencyPrices, setCurrencyPrices] = useState();

    useEffect(() => {
        const getCurrencies = () => {
            geoService
                .GetPrices(code)
                .then(res => setCurrencyPrices(res))
        }
        if (code) getCurrencies();
    }, [code])

    return {
        currencyPrices
    }
}
export default useCurrencyPrices;